module.exports = __webpack_public_path__ + "static/media/IMG_0290.5bc9bc15.JPG";